import { render, staticRenderFns } from "./SalesOrderStatus.vue?vue&type=template&id=36c75086&scoped=true&"
import script from "./SalesOrderStatus.vue?vue&type=script&lang=js&"
export * from "./SalesOrderStatus.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderStatus.vue?vue&type=style&index=0&id=36c75086&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c75086",
  null
  
)

export default component.exports